module.exports = __webpack_public_path__ + "static/course1-d4136c63f03383d3de27042a6347cfa9.jpg";